import { Nominal } from 'simplytyped';
import { FormulaCalculatorUtils } from './formula-calculator-utils';

/**
 * This file should be kept identical in both AdminUI and AWS-Stack and AWS stack is source of truth!!!!.
 */

//duplicate of the standard types as file needs to work in Admin UI
export type Millimeters = Nominal<number, 'mm'>;
export type Litres = Nominal<number, 'litre'>;

export type CustomFormulaResult = {
	volume: Litres;
	height?: Millimeters;
	maxVolume?: Litres;
	debugInfo?: Record<string, any>;
};
export type AdditionalFeedParams = {
	prevRefillHeight?: Millimeters;
	prevLevelHeight?: Millimeters;
};

export type AdditionalVatParams = {
	offset: number;
	emptyDistance?: number;
	volumeCalibration?: number;
};

export abstract class CustomFormulaCalculator {
	public static calculateVolume(params: {
		distances: Millimeters[];
		entityType: 'feedTank';
		entityId?: number | string;
		entityParameters: Record<string, number | string>;
		entityCorrections?: Record<string, number | null>;
		formula: string;
		formulaName: string;
		additionalFeedParams: AdditionalFeedParams;
	}): CustomFormulaResult[] | Error;
	public static calculateVolume(params: {
		distances: Millimeters[];
		entityType: 'vat';
		entityId?: number | string;
		entityParameters: Record<string, number | string>;
		formula: string;
		formulaName: string;
		additionalVatParams: AdditionalVatParams;
	}): CustomFormulaResult[] | Error;
	public static calculateVolume(params: {
		distances: Millimeters[];
		entityType: 'vat' | 'feedTank';
		entityId?: number | string;
		entityParameters: Record<string, number | string>;
		entityCorrections?: Record<string, number | null>;
		formula: string;
		formulaName: string;
		additionalFeedParams?: AdditionalFeedParams;
		additionalVatParams?: AdditionalVatParams;
	}): CustomFormulaResult[] | Error {
		const {
			distances,
			entityParameters,
			formulaName,
			formula,
			entityType,
			entityId,
			additionalFeedParams,
			additionalVatParams,
		} = params;
		const entityCorrections = params.entityCorrections;
		const formulaResults: CustomFormulaResult[] = [];

		let fullParams: Record<string, number | string>;
		for (const dist of distances) {
			if (entityType === 'vat') {
				fullParams = this.getFormulaParametersForVat(entityParameters, dist, additionalVatParams);
			} else {
				fullParams = this.getFormulaParametersForFeedTank(
					entityParameters,
					dist,
					additionalFeedParams,
				);
			}
			if (entityCorrections) {
				fullParams = FormulaCalculatorUtils.appendParametersWithCorrections(
					fullParams,
					entityCorrections,
				);
			}

			const formulaWithParams = FormulaCalculatorUtils.addParamsToFormula(fullParams, formula);
			const formulaResult = this.evaluateFormula(formulaWithParams, formulaName, entityId);

			if (formulaResult instanceof Error) {
				return formulaResult;
			} else {
				formulaResults.push(formulaResult);
			}
		}
		return formulaResults;
	}

	static getFormulaParametersForVat(
		vatFormulaParameters: Record<string, number | string>,
		dist: number,
		additionalVatParams?: AdditionalVatParams,
	): Record<string, number | string> {
		const params = <Record<string, number | string>>{
			...vatFormulaParameters,
			...{
				reading: dist,
				offset: additionalVatParams?.offset ?? 0,
				emptyDistance: additionalVatParams?.emptyDistance ?? undefined,
				calibration: additionalVatParams?.volumeCalibration ?? 0,
			},
		};
		return params;
	}

	static getFormulaParametersForFeedTank(
		feedTankFormulaParameters: Record<string, number | string>,
		dist: number,
		additionalFormulaParams?: AdditionalFeedParams,
	): Record<string, number | string> {
		const params = <Record<string, number | string>>{
			...feedTankFormulaParameters,
			...additionalFormulaParams,
			reading: dist,
		};

		return params;
	}

	private static evaluateFormula(
		formula: string,
		formulaName: string,
		entityId: number | string | undefined,
	): CustomFormulaResult | Error {
		let volume, Hm, maxVolume, debugInfo;
		try {
			eval(formula);
		} catch (err) {
			return new Error(`Error calculating formula for entityId:${entityId}: ${err.message}.
			Formula =
			${formula}`);
		}

		if (
			volume != undefined &&
			Number.isFinite(+volume) &&
			(Hm == undefined || Number.isFinite(+Hm)) &&
			(maxVolume == undefined || Number.isFinite(+maxVolume))
		) {
			return {
				volume: <Litres>Math.round(volume),
				height: Hm !== undefined ? <Millimeters>Math.round(Hm) : undefined,
				maxVolume: maxVolume !== undefined ? <Litres>Math.round(maxVolume) : undefined,
				debugInfo,
			};
		} else {
			return new Error(
				`Formula ${formulaName} did not generate valid outputs for volume and height .
				 volume=${volume}, Hm=${Hm} for entityId ${entityId}
				 Formula =

				 ${formula}`,
			);
		}
	}
}
